export const LUGGAGE_WEIGHT = 'luggage-weight';
export const LUGGAGE_PRICE = 'luggage-price';

const names = {
    [LUGGAGE_WEIGHT]: 'Poids du bagage',
    [LUGGAGE_PRICE]: 'Prix par bagage',
};

export const selectOptions = [
    {
        value: LUGGAGE_WEIGHT,
        label: miscName(LUGGAGE_WEIGHT)
    },
    {
        value: LUGGAGE_PRICE,
        label: miscName(LUGGAGE_PRICE)
    },
];


export function miscName(type) {
    return names[type];
}
